<template>
  <component
    :is="component"
    class="relative"
    :to="to"
    :target="target">
    <Typography
      as="span"
      :variant="variant"
      :class="[
        props.hasIcon ? 'inline-flex items-center gap-1' : 'inline',
        'bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat transition-[background-size] duration-300',
        underline
          ? [
            'bg-[length:100%_1px]',
            'bg-[position:0_100%]',
            'hover:bg-[length:0%_1px] hover:bg-[position:100%_100%]',
            'group-hover:bg-[length:0%_1px] group-hover:bg-[position:100%_100%]',
          ]
          : [
            'bg-[length:0%_1px] bg-[position:0_100%]',
            'hover:bg-[length:100%_1px] hover:bg-[position:0_100%]',
            'group-hover:bg-[length:100%_1px] group-hover:bg-[position:0_100%]',
          ],
      ]">
      <slot />
      <slot name="icon" />
    </Typography>
  </component>
</template>

<script setup lang="ts">
import { Typography, CustomNuxtLink } from '@gro-up/ui/primitives'
import type { NuxtLinkProps } from 'nuxt/app'
import { computed } from 'vue'

import type { TypographyVariant } from '../Typography/Typography.vue'

export type LinkComponentType = 'span' | 'NuxtLink'

export type LinkProps = {
  as?: LinkComponentType
  underline?: boolean
  variant?: TypographyVariant
  to?: NuxtLinkProps['to']
  target?: string
  hasIcon?: boolean
}

const props = withDefaults(defineProps<LinkProps>(), {
  variant: 'body',
  as: 'NuxtLink',
  to: undefined,
  target: undefined,
  hasIcon: false,
})

const component = computed(() => {
  if (props.as === 'NuxtLink') {
    return CustomNuxtLink
  }
  return props.as
})
</script>
